import React from 'react';

class Settings extends React.Component {

  static defaultProps = {
    integration: 'rewarded',
    format: 'basic',
    pays: 'min $0.3'
  }

  displayFormat = () => {
    if(this.props.format === 'third-party'){
      return 'Mediation'
    }

    return this.props.format;
  }

  render() {
    const isOfferwall = this.props.integration === 'offerwall';
    return (
      <div className="settings">
        <p><b>Current Screen</b></p>
        { !isOfferwall && (
          <div>
            Integration: <span style={{ color: '#e4401c', textTransform: 'capitalize' }}>{ this.props.integration }</span> |
            Format: <span style={{ color: '#e4401c', textTransform: 'capitalize' }}>{ this.displayFormat() }</span> |
            Pays: <span style={{ color: '#e4401c'}}>{ this.props.pays }</span>
          </div>
        )}
        { isOfferwall && (
          <div>
            Approach: <span style={{ color: '#e4401c', textTransform: 'capitalize' }}>Offerwall</span>
          </div>
        )}
      </div>
    );
  }
}

export default Settings;



// WEBPACK FOOTER //
// ./src/components/weather/settings.js